import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'id',
  })
  let treatment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.ledger.treatment_id',
  })
  let payors = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.ledger.payors',
  })

  return {
    variables: {
      where: {
        patient_id: { _eq: patient_id },
        treatment_id: treatment_id ? { _eq: treatment_id } : undefined,
        _or: payors.length
          ? payors.map(p => ({
              payment_account_id: { _eq: p.payment_account_id },
              insured_id:
                p.insured_id !== null
                  ? { _eq: p.insured_id }
                  : { _is_null: true },
            }))
          : undefined,
      },
      treatment_id,
      has_treatment: !!treatment_id,
    },
    pause: !patient_id,
  }
}
